import * as React from "react";
const AiFillIcon = ({
  size = 16,
  title = "AiFillIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m14.697 8.49-2.83 1.415a4.386 4.386 0 0 0-1.962 1.962l-1.414 2.83a.548.548 0 0 1-.981 0l-1.415-2.83a4.387 4.387 0 0 0-1.962-1.962l-2.83-1.414a.548.548 0 0 1 0-.981l2.83-1.415a4.387 4.387 0 0 0 1.962-1.962l1.415-2.83a.548.548 0 0 1 .98 0l1.415 2.83a4.387 4.387 0 0 0 1.962 1.962l2.83 1.415a.548.548 0 0 1 0 .98Z", fill: "currentColor" }));
export default AiFillIcon;
